import React, {
    useContext, useState
} from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Link } from '@jutro/router';
import { FormModalPopover} from 'ml-components-platform-react';
import { useModal } from '@jutro/components';
import cx from 'classnames';
import { MLModalService } from 'ml-portals-services-react';
import messages from './MLHOPConstruction.messages'
import { PolicyService } from 'gw-capability-gateway';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLPropertyValuationService  } from 'ml-services-common-react';

import styles from '../../MLSummary.module.scss'
import {Button, IconButton } from '@jutro/legacy/components';

import aerialImageryPopup from './popup/aerialImageryPopup.metadata.json5';

import { IntlContext } from '@jutro/legacy/locale';

function MLHOPConstruction({ data, getFormattedCurrency, show, productCode, policyNumber }) {
    const modalApi = useModal();
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const [constructionExpanded, setConstructionExpanded] = useState(true);
    const { authHeader } = useAuthentication();
    const {
        addWarningAlert ,
        clearBlockAlerts
    } = MLNotificationBlockUtil();

    const {
        showErrorModal,
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const showAerialImageryLink = (productCode === 'hopdwelling' || productCode === 'hop_landlord_home_ml')

    if (_.isEmpty(data)) {
        return null;
    }

    const formatDate = (gwDateVal) => {
        const date = LocalDateUtil.toMidnightDate(gwDateVal);
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' })
    };

    const translateTypeKey = (typekey) => {
        if(typekey){
            return translator({id: typekey, defaultMessage: typekey});
        }
    }

    const getYesNo = (excluded) => {
        if(excluded){
            return translator(messages.Yes);
        }
        return translator(messages.No);
    }

    const getTypeListDisplayName = (typelist, value) => {
        if (!value) {
            return undefined;
        }
        return viewModelService.productMetadata.get('pc').types.getTypelist(typelist).getCode(value).name;
    };

    const toggleConstructionDetails = () => {
        setConstructionExpanded(!constructionExpanded);
    };

    const getNewAmountDTO = (amount) => {
        return { currency: 'usd', amount: amount };
    };

    const getPercentageBasementText = (details) => {
        if (details.finishedBasement_ML === undefined) {
            return translator(messages.DashDash);
        }
        return translator(`%${details.finishedBasement_ML}`);
    };

    const getFireplaceTypeText = () => {
        if (data.fireplaces.length === 0) {
            return translator(messages.DashDash);
        }
        let result = '';
        data.fireplaces.forEach((fireplace) => {
            result = result.concat(translateTypeKey(getTypeListDisplayName('FireplaceType_ML', fireplace.fireplaceType))).concat(', ');
        });
        result = result.replace(/,\s*$/, '');
        return result;
    };

    const generateDwellingCharacteristics = () => {
        if (constructionExpanded) {
            return (
                <tbody ng-show="constructionExpanded">
                    { data.constructionVerisk.inflationOrRCRefApplied_Ext && (
                    <tr>
                        <td className="col-sm-5"><strong>{translator(messages.inflationOrRCApplied)}</strong></td>
                        <td>{data.constructionVerisk.inflationOrRCRefApplied_Ext}</td>
                    </tr>
                    )}
                    <tr>
                        <td colSpan="2">
                            <h2 className="subsection-header">
                                {translator(messages.DwellingCharacteristics)}
                            </h2>
                        </td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.YearBuilt)}</strong></td>
                        <td>{data.constructionVerisk.yearBuilt}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.ConstructionType)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('HOPConstructionType', data.constructionVerisk.constructionType))}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.NumFamilies)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('HOPNumFamilies_ML', data.constructionVerisk.numFamilies_ML))}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.HouseAge)}</strong></td>
                        <td>{data.houseAge}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.ApproxSquareFootage)}</strong></td>
                        <td>{data.constructionVerisk.approxSquareFootage_ML}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.NumStories)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('NumberOfStories', data.constructionVerisk.numStories_ML))}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.NumFullBathrooms)}</strong></td>
                        <td>{data.constructionVerisk.numFullBathrooms_ML || 0}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.NumThreeQuarterBathrooms)}</strong></td>
                        <td>{data.constructionVerisk.numThreeQuarterBathrooms_ML || 0}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.NumHalfBathrooms)}</strong></td>
                        <td>{data.constructionVerisk.numHalfBathrooms_ML || 0}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.NumBedrooms)}</strong></td>
                        <td>{data.constructionVerisk.numBedrooms_ML}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.ExteriorWallFinish)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('ExteriorWallType_ML', data.constructionVerisk.exteriorWallType_ML))}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.AttachedGarages)}</strong></td>
                        <td>{getYesNo(data.constructionVerisk.attachedGarage_ML)}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.AttachedGaragesNumCars)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('HOPNumCars_ML', data.constructionVerisk.attachedGarageCars_ML)) || 0}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.DetachedGarages)}</strong></td>
                        <td>{getYesNo(data.constructionVerisk.detachedGarage_ML)}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.DetachedGaragesNumCars)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('HOPNumCars_ML', data.constructionVerisk.detachedGarageCars_ML)) || 0}</td>
                    </tr>
                </tbody>
            );
        }
        return ( <></> );
    }

    const generateFoundation = () => {
        if (constructionExpanded) {
            return (
                <tbody ng-show="constructionExpanded">
                    <tr>
                        <td colSpan="2">
                            <h2 className="subsection-header">
                                {translator(messages.Foundation)}
                            </h2>
                        </td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.FoundationType)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('FoundationType', data.constructionVerisk.foundationType))}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.PercentageBasementFinished)}</strong></td>
                        <td>{getPercentageBasementText(data.constructionVerisk)}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.WalkoutBasement)}</strong></td>
                        <td>{getYesNo(data.constructionVerisk.hasWalkoutBasement_ML)}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.FoundationMaterial)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('FoundationMaterialType_ML', data.constructionVerisk.foundationMaterialType_ML))}</td>
                    </tr>
                </tbody>
            );
        }
        return ( <></> );
    }
    
    const generateRoof = () => {
        if (constructionExpanded) {
            return (
                <tbody ng-show="constructionExpanded">
                    <tr>
                        <td colSpan="2">
                            <h2 className="subsection-header">
                                {translator(messages.Roof)}
                            </h2>
                        </td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.RoofCoveringType)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('RoofCoveringType_ML', data.constructionVerisk.roofCoveringType_ML))}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.RoofShape)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('RoofShape_ML', data.constructionVerisk.roofShape_ML))}</td>
                    </tr>
                </tbody>
            );
        }
        return ( <></> );
    }

    const generateHeating = () => {
        if (constructionExpanded) {
            return (
                <tbody ng-show="constructionExpanded">
                    <tr>
                        <td colSpan="2">
                            <h2 className="subsection-header">
                                {translator(messages.Heating)}
                            </h2>
                        </td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.PrimaryHeatingSystem)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('HeatingSystemType_ML', data.constructionVerisk.primaryHeatingSystemType_ML))}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.SecondaryHeatingSystem)}</strong></td>
                        <td>{translateTypeKey(getTypeListDisplayName('HeatingSystemType_ML', data.constructionVerisk.secondaryHeatingSystemType_ML)) || translator(messages.DashDash)}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.Fireplaces)}</strong></td>
                        <td>{data.fireplaces.length}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.FireplaceType)}</strong></td>
                        <td>{getFireplaceTypeText()}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.ValuationID)}</strong></td>
                        <td>{data.constructionVerisk.verisk360ValuationID_ML}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.Version)}</strong></td>
                        <td>{data.constructionVerisk.verisk360Version_ML}</td>
                    </tr>
                    <tr>
                        <td className="col-sm-5 sub-cell"><strong>{translator(messages.VersionDate)}</strong></td>
                        <td>{formatDate(data.constructionVerisk.verisk360VersionDate_ML)}</td>
                    </tr>

                </tbody>
            );
        }
        return ( <></> );
    }

    const openImageryModal = () => {
        clearBlockAlerts('imagery');
        showProgressDialog(messages.loadingImagery)

        MLPropertyValuationService.getImageryLinkByPolicyNumber(policyNumber, authHeader).then((url) => {
            hideProgressDialog();
            
            if(url === "") { 
                addWarningAlert(messages.imageryUnavailable, 'imagery')
                setTimeout(() => {
                window.scrollTo(0, 0);
                 }, 100)
                
                return;
            }

            const componentProps = {
                showHeader: false,
                showActionButton: false,
                cancelBtnLabel: messages.close,
                uiProps: aerialImageryPopup.pageContent,
                closeOnOverlayClick: true,
                closeOnEsc: true,
                getOverrideProps: () => {
                    return {
                        iframe: {
                            src: url
                        }
                    };
                }
                
            
            };

            modalApi.showModal(
                <FormModalPopover {...componentProps} />)
                
        }, () => {
            hideProgressDialog()
            addWarningAlert(messages.imageryUnavailable, 'imagery')
            window.scrollTo(0, 0);
        })
    }

    const showReplacementCostSummaryLink = data.constructionVerisk.verisk360ValuationID_ML
        && data.constructionVerisk.verisk360Version_ML;

    const onClickReplacementCostSummary = async () => {
        clearBlockAlerts('replacementCost');
        
        const displayErrorModal = () => {
            showErrorModal(messages.documentError, messages.downloadDocError);
        };
        const valuationID = data.constructionVerisk.verisk360ValuationID_ML;
        const valuationVersion = data.constructionVerisk.verisk360Version_ML;

        showProgressDialog(messages.loadingReplacementCost);
        const fileName = `360Value Replacement Cost Valuation ${valuationID}.${valuationVersion}.pdf`;
        // const appendToUrl = `${policyNumber}?valuationID=${valuationID}&valuationVersion=${valuationVersion}&fileName=${encodeURIComponent(fileName)}`;
        const appendToUrl = `${policyNumber}?valuationID=${valuationID}&valuationVersion=${valuationVersion}&policyNumber=${policyNumber}&fileName=${encodeURIComponent(fileName)}`;

        await GatewayDocumentService.downloadDocumentPreview(appendToUrl, authHeader, displayErrorModal, false);
        hideProgressDialog();
    }

    if (show) {
        const iconStyle = constructionExpanded? cx(styles.iconBlue, 'icon-accordion-down', 'icon-inline') : cx(styles.iconBlue, 'icon-accordion-down', 'icon-rotate-180', 'icon-inline')
        return (
            <div className="vertical-spacing-40">
                <hr className="vertical-spacing-30" />
                <div className="col-sm-2">
                    <h2 className="section-header vertical-spacing-20">
                        {translator(messages.Construction)}
                    </h2>
                </div>
                <div>
                   { showAerialImageryLink && (
                    <Link
                        className={styles.aerialImageryLink}
                        onClick={openImageryModal}
                    >
                        {translator(messages.aerialImagery)}
                    </Link>
        )}
                   { showReplacementCostSummaryLink && (
                    <Button
                    className={styles.pullRight} type="outlined" style ={{marginTop: '-12px', marginRight: '5px', marginBottom: '15px', marginLeft: '5px'}}
                    onClick={onClickReplacementCostSummary}
                    >
                    {translator(messages.viewReplacementCostSummary)}
                </Button>
                )}
                </div>
                <table className={cx('table table-bordered table-data-vertical', styles.noLeftRightBorders)}>
                    <tbody>
                        <tr>
                            <td className="col-sm-5">
                                <h2 className="subsection-header">
                                    <IconButton
                                        onClick={() => toggleConstructionDetails()}
                                        role="menuitem"
                                        icon="icon-accordion-down"
                                        className={iconStyle}
                                    />
                                    {translator(messages.EstimatedReplacementCost)}
                                </h2>
                            </td>
                            <td>{getFormattedCurrency(getNewAmountDTO(data.constructionVerisk.replacementCost))}</td>
                        </tr>
                    </tbody>
                    {generateDwellingCharacteristics()}
                    {generateFoundation()}
                    {generateRoof()}
                    {generateHeating()}
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLHOPConstruction.propTypes = {
    data: PropTypes.shape([]),
    getFormattedCurrency: PropTypes.func.isRequired,
    show: PropTypes.bool
};
MLHOPConstruction.defaultProps = {
    data: [],
    show: false
};
export default MLHOPConstruction;
